// extracted by mini-css-extract-plugin
export default {"reg_form":"newReg_reg_form__bi2rR","errorMessage":"newReg_errorMessage__4tP+7","successMessage":"newReg_successMessage__MLgwc"};